import React from "react"

export const BlankFullWidthTemplate = ({ id, content }) => (
    <div className={`post-${id}`}>
        <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
)

export default BlankFullWidthTemplate
